// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Pagination } from '@/components';
import { Table } from '@/ui';
import { StyledWrapper } from './SubscriptionsListStyles';
import { SubscriptionsFiltersContainer } from '../../containers';

// Models
import { ISubscription } from '@/models/subscriptions.model';

// Helpers
import { getSubscriptionsTableColumns } from './columns';

type TSubscriptionsList = {
  list: ISubscription[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onDelete: (item: ISubscription) => void;
  onPageChange: (page: number) => void;
  canManage: boolean;
};

const SubscriptionsList = ({
  list,
  isLoading,
  currentPage,
  total,
  onPageChange,
  onDelete,
  canManage,
}: TSubscriptionsList) => {
  const { t } = useTranslation(['subscriptions']);

  return (
    <StyledWrapper>
      <Table
        scroll={{ x: 'max-content' }}
        columns={getSubscriptionsTableColumns({ t, onDelete, total, canManage })}
        dataSource={list}
        rowKey="id"
        loading={isLoading}
        components={{
          header: {
            wrapper: SubscriptionsFiltersContainer,
          },
        }}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} hideOnSinglePage />
    </StyledWrapper>
  );
};

export default SubscriptionsList;
